import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {
  applyAdminThemeTokens,
  readCachedAdminThemeTokens,
  readCachedAdminThemeLogo,
  updateFavicon,
} from './app/core/theme/admin-theme-tokens-applier';

const cachedThemeTokens = readCachedAdminThemeTokens();
if (cachedThemeTokens) {
  applyAdminThemeTokens(cachedThemeTokens);
}

const cachedLogo = readCachedAdminThemeLogo();
if (cachedLogo) {
  updateFavicon(cachedLogo);
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
